const COPY_MARK = " — Copy";

const parseDuplicateStem = (title) => {
  const raw = String(title || "").trim() || "Event";
  const numbered = raw.match(/^(.*) — Copy (\d+)$/);
  if (numbered) return numbered[1].trim() || "Event";
  if (raw.endsWith(COPY_MARK)) {
    const stem = raw.slice(0, -COPY_MARK.length).trim();
    return stem || "Event";
  }
  return raw;
};

export const nextDuplicateTitle = (originalTitle, existingTitles = []) => {
  const stem = parseDuplicateStem(originalTitle);
  const taken = new Set(
    (existingTitles || []).map((title) => String(title || "").trim().toLowerCase()).filter(Boolean)
  );

  const first = `${stem}${COPY_MARK}`;
  if (!taken.has(first.toLowerCase())) return first;

  let n = 2;
  while (taken.has(`${stem}${COPY_MARK} ${n}`.toLowerCase())) {
    n += 1;
  }
  return `${stem}${COPY_MARK} ${n}`;
};
